"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboDriverPriceFromTotalPrice = void 0;
function getComboDriverPriceFromTotalPrice(offer) {
    return offer.totalPrice.total - offer.totalPrice.fee + offer.subsidy;
}
exports.getComboDriverPriceFromTotalPrice = getComboDriverPriceFromTotalPrice;
//# sourceMappingURL=getComboDriverPriceFromTotalPrice.js.map